import { render, staticRenderFns } from "./orderTotal.vue?vue&type=template&id=6bf59fcc&scoped=true"
import script from "./orderTotal.vue?vue&type=script&lang=ts"
export * from "./orderTotal.vue?vue&type=script&lang=ts"
import style0 from "./orderTotal.vue?vue&type=style&index=0&id=6bf59fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf59fcc",
  null
  
)

export default component.exports